import BrandPageBestsellerRankingPage from "@faire/prototype-playground/workspace/pa/brand-page-bestseller-ranking";
import BrandPageNewTabDateGroupsPage from "@faire/prototype-playground/workspace/pa/brand-page-new-tab-date-groups";
import { Route, Switch } from "react-router-dom";

export function PedroAlvesRoutes() {
  return (
    <Switch>
      <Route
        path="/pa/brand-page-bestseller-ranking"
        component={BrandPageBestsellerRankingPage}
      />
      <Route
        path="/pa/brand-page-new-tab-date-groups"
        component={BrandPageNewTabDateGroupsPage}
      />
    </Switch>
  );
}

export const slug = "pa";
